/**
 * Property Status Chart Component
 * Displays property status distribution
 */

import React from "react";
import {
	Cell,
	Legend,
	Pie,
	PieChart,
	ResponsiveContainer,
	Tooltip,
} from "recharts";

interface PropertyStatusChartProps {
	data: Array<{
		name: string;
		value: number;
		color: string;
	}>;
}

const PropertyStatusChart: React.FC<PropertyStatusChartProps> = ({ data }) => {
	return (
		<div className="bg-card border border-border rounded-lg p-6">
			<h3 className="text-lg font-semibold text-foreground mb-4">
				Property Status Distribution
			</h3>
			<ResponsiveContainer width="100%" height={350}>
				<PieChart>
					<Pie
						data={data}
						cx="50%"
						cy="45%"
						labelLine={true}
						label={({ name, percent, value }) => {
							// Only show label if segment is large enough (>5%)
							if (percent < 0.05) return "";
							return `${name}: ${(percent * 100).toFixed(0)}%`;
						}}
						outerRadius={90}
						innerRadius={0}
						fill="#8884d8"
						dataKey="value"
						paddingAngle={2}
					>
						{data.map((entry, index) => (
							<Cell key={`cell-${index}`} fill={entry.color} />
						))}
					</Pie>
					<Tooltip
						contentStyle={{
							backgroundColor: "hsl(var(--card))",
							border: "1px solid hsl(var(--border))",
							borderRadius: "6px",
						}}
						formatter={(value: number, name: string, props: any) => [
							`${value} (${((props.payload.percent || 0) * 100).toFixed(1)}%)`,
							props.payload.name,
						]}
					/>
					<Legend
						verticalAlign="bottom"
						height={36}
						iconType="circle"
						wrapperStyle={{ fontSize: "12px" }}
					/>
				</PieChart>
			</ResponsiveContainer>
		</div>
	);
};

export default PropertyStatusChart;
